<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <div class="block-header">
          <h2>DASHBOARD Simpeg</h2>
        </div>


<div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="header bg-light-blue">
                <h4>APLIKASI TERKAIT</h4>
                <h6>APLIKASI PENDUKUNG KEPEGAWAIAN PEMDA KAB. KONAWE SELATAN</h6>
              </div>
              <div class="body" style="background-color:#ededed;">
                <div class="row">
                  <div class="col-md-6">
                    <div style="background-color:white; border-radius:5px; box-shadow: 2px 2px 5px grey;">
                      <a href="http://sidilan.konaweselatankab.go.id/" target="_blank">
                        <img class="img-responsive" src="images/SIDILAN.png" alt="">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6" style="padding:100">
                    <div style="background-color:white; border-radius:5px; box-shadow: 2px 2px 5px grey;">
                      <a href="http://simantan.konaweselatankab.go.id/" target="_blank">
                        <img class="img-responsive" src="images/SIMANTAN.png" alt="">
                      </a>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
        <!-- Widgets -->
        <div class="row clearfix">
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div class="info-box bg-light-blue hover-expand-effect">
              <div class="icon">
                <i class="material-icons">person_add</i>
              </div>
              <div class="content">
                <div class="text">JUMLAH PEGAWAI</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="125"
                  data-speed="15"
                  data-fresh-interval="20"
                >{{data.jumlah_pegawai}}</div>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-cyan hover-expand-effect">
              <div class="icon">
                <i class="material-icons">assignment_returned</i>
              </div>
              <div class="content">
                <div class="text">JUMLAH WANITA</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="257"
                  data-speed="1000"
                  data-fresh-interval="20"
                >1</div>
              </div>
            </div>
          </div> -->

          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div class="info-box bg-light-green hover-expand-effect">
              <div class="icon">
                <i class="material-icons">assignment_turned_in</i>
              </div>
              <div class="content">
                <div class="text">JUMLAH PRIA</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="243"
                  data-speed="1000"
                  data-fresh-interval="20"
                >{{data.jml_pria}}</div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div class="info-box bg-orange hover-expand-effect">
              <div class="icon">
                <i class="material-icons">assignment_late</i>
              </div>
              <div class="content">
                <div class="text">JUMLAH WANITA</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="1225"
                  data-speed="1000"
                  data-fresh-interval="20"
                >{{data.jml_wanita}}</div>
              </div>
            </div>
          </div>
        </div>


        <!-- #END# Widgets -->
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="header bg-light-green">
                <h5>PRESENTASE BERDASARKAN JENIS KELAMIN</h5>
              </div>
              <div class="body">
                <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="presentase_jenis_kelamin" width="400" height="200"></canvas>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="header bg-light-green">
                <h5>PRENSENTASE PENDIDIKAN AKHIR (FORMAL)</h5>
              </div>
              <div class="body">
                <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="presentase_sekolah" width="400" height="200%"></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="header bg-light-blue">
                <h5>JUMLAH BERDASARKAN PANGKAT/GOL</h5>
              </div>
              <div class="body">
                <div class="table-responsive" style="height : 450px !important; overflow-y: auto !important; padding-bottom:20px !important;">
                    <table class="table-bordered" width="100%">
                      <thead>
                        <tr>
                          <th>Gilongan</th>
                          <th>Jumlah ASN</th>
                        </tr>
                      </thead>
                      <tbody  class="h_isitable" >
                        <tr>
                          <td>IV-D / Pembina Utama Madya</td>
                          <td>{{data.gol_ahir_4d}}</td>
                        </tr>
                        <tr>
                          <td>IV-C / Pembina Utama Muda</td>
                          <td>{{data.gol_ahir_4c}}</td>
                        </tr>
                        <tr>
                          <td>IV-B / Pembina Tingkat 1</td>
                          <td>{{data.gol_ahir_4b}}</td>
                        </tr>
                        <tr>
                          <td>IV-A / Pembina</td>
                          <td>{{data.gol_ahir_4a}}</td>
                        </tr>
                        <tr>
                          <td>III-D / Penata Tingkat 1</td>
                          <td>{{data.gol_ahir_3d}}</td>
                        </tr>
                        <tr>
                          <td>III-C / Penata</td>
                          <td>{{data.gol_ahir_3c}}</td>
                        </tr>
                        <tr>
                          <td>III-B / Penata Muda Tingkat 1</td>
                          <td>{{data.gol_ahir_3b}}</td>
                        </tr>
                        <tr>
                          <td>III-A / Penata Muda</td>
                          <td>{{data.gol_ahir_3a}}</td>
                        </tr>
                        <tr>
                          <td>II-D / Pengatur Tingkat 1</td>
                          <td>{{data.gol_ahir_2d}}</td>
                        </tr>
                        <tr>
                          <td>II-C / Pengatur</td>
                          <td>{{data.gol_ahir_2c}}</td>
                        </tr>
                        <tr>
                          <td>II-B / Pengatur Muda Tingkat 1</td>
                          <td>{{data.gol_ahir_2b}}</td>
                        </tr>
                        <tr>
                          <td>II-A / Pengatur Muda</td>
                          <td>{{data.gol_ahir_2a}}</td>
                        </tr>
                        <tr>
                          <td>I-D / Juru Tingkat 1</td>
                          <td>{{data.gol_ahir_1d}}</td>
                        </tr>
                        <tr>
                          <td>I-C / Juru</td>
                          <td>{{data.gol_ahir_1c}}</td>
                        </tr>
                        <tr>
                          <td>I-B / Juru Muda Tingkat 1</td>
                          <td>{{data.gol_ahir_1b}}</td>
                        </tr>
                        <tr>
                          <td>I-A/ Juru Muda</td>
                          <td>{{data.gol_ahir_1a}}</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="header bg-orange">
                <h5>JUMLAH BERDASARKAN PENDIDIKAN AKHIR (FORMAL)</h5>
              </div>
              <div class="body ">
                <div class="table-responsive" style="height : 450px !important; overflow-y: auto !important; padding-bottom:20px !important;">
                    <table class="table-bordered" width="100%">
                      <thead>
                        <tr>
                          <th>Gilongan</th>
                          <th>Jumlah ASN</th>
                        </tr>
                      </thead>
                      <tbody  class="h_isitable" >
                        <tr>
                          <td>S3</td>
                          <td>{{data.pendidikan_ahir_s3}}</td>
                        </tr>
                        <tr>
                          <td>S2</td>
                          <td>{{data.pendidikan_ahir_s2}}</td>
                        </tr>
                        <tr>
                          <td>S1 / D-IV</td>
                          <td>{{data.pendidikan_ahir_s1}}</td>
                        </tr>
                        <tr>
                          <td>D-III</td>
                          <td>{{data.pendidikan_ahir_d3}}</td>
                        </tr>
                        <tr>
                          <td>D-II</td>
                          <td>{{data.pendidikan_ahir_d2}}</td>
                        </tr>
                        <tr>
                          <td>D-I</td>
                          <td>{{data.pendidikan_ahir_d1}}</td>
                        </tr>
                        <tr>
                          <td>SMA/Sederajat</td>
                          <td>{{data.pendidikan_ahir_SLTA}}</td>
                        </tr>
                        <tr>
                          <td>SLTP/Mts</td>
                          <td>{{data.pendidikan_ahir_sltp}}</td>
                        </tr>
                        <tr>
                          <td>SD</td>
                          <td>{{data.pendidikan_ahir_sd}}</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="header  bg-light-green">
                <h4>REKOMENDASI PENSIUN TAHUN INI</h4> 
                <h6>Jumlah Pensiun Tahun ini : {{list_data.length}} ASN</h6>
              </div>
              <div class="body">
                <div class="table-responsive" style="height : 450px !important; overflow-y: auto !important; padding-bottom:20px !important;">
                    <table class="table-bordered" width="100%">
                      <thead>
                        <tr>
                          <th width="10%"></th>
                          <th width="15%">Nama</th>
                          <th width="10%">Nip</th>
                          <th width="10%">TTL</th>
                          <th width="25%">Jabatan</th>
                          <th width="20%">Unit Kerja</th>
                          <th width="10%">Usia (Thn)</th>
                        </tr>
                      </thead>
                      <tbody  class="h_isitable" >
                        <tr v-for="data in list_data" :key="data.id">
                          <td class="text-center">
                            <img src="images/no_image.png" width="50px" alt="">
                          </td>
                          <td>{{check_gelar_depan(data.gelar_depan)}}{{data.nama}}{{check_gelar_belakang(data.gelar_belakang)}}</td>
                          <td>{{data.nip}}</td>
                          <td>{{data.ttl}}</td>
                          <td>{{data.nm_jabatan}}</td>
                          <td>{{data.nm_unit_kerja}}</td>
                          <td>{{data.thn_usia}}</td>
                        </tr>

                      </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>


        



      </div>

      <!-- <button @click="office">office</button>
      <button @click="monev">monev</button>
      <button @click="sakip">sakip</button> -->

    </section>
  </div>
</template>

<script>
import Chart from "chart.js";

const ADD_URL = URL_APP+'api/v1/simpeg_home/';

export default {
  data() {
    return {
      list_data : [],
      data : {}
    };
  },
  methods: {
    getData: function(){
      fetch(ADD_URL+'jml_pegawai', {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization : 'kikensbatara '+localStorage.token
          },
      })
      .then(res => res.json())
      .then((res_data) => {
          console.log(res_data)
          this.data = res_data;
          this.presentase_sekolah();
          this.presentase_jenis_kelamin();
          this.getDataPensiun();
      });
    },

    getDataPensiun: function(){
      fetch(ADD_URL+'jml_pensiun', {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization : 'kikensbatara '+localStorage.token
          },
      })
      .then(res => res.json())
      .then((res_data) => {
        this.list_data = res_data
      });
    },

    check_gelar_depan : function(data){
        if (data == undefined || data == null || data == '') {
            return ''
        } else {
            return data+'. '
        }
    },
    check_gelar_belakang : function(data){
        if (data == undefined || data == null || data == '') {
            return ''
        } else {
            return ', '+data
        }
    },

// ========================================== CHART ===========================================
    presentase_sekolah: function() {
      var data = this.data
      var ctx = document.getElementById("presentase_sekolah").getContext("2d");

      var myChart = new Chart(ctx, {
        type: "bar",
        data: {
        labels: ["SD", "SMP/Mts", "SMA(Sederajat)", "D1", "D2", "D3",  "S1/D4", "S2", "S3"],
        datasets: [{
            label: "Jumlah ASN",
            data: [data.pendidikan_ahir_sd, data.pendidikan_ahir_sltp, data.pendidikan_ahir_SLTA, data.pendidikan_ahir_d1, data.pendidikan_ahir_d2, data.pendidikan_ahir_d3, data.pendidikan_ahir_s1, data.pendidikan_ahir_s2, data.pendidikan_ahir_s3],
            borderColor: 'rgba(0, 188, 212, 0.8)',
            backgroundColor: 'rgba(0, 188, 212, 0.5)',
            pointBorderColor: 'rgba(0, 188, 212, 0)',
            pointBackgroundColor: 'rgba(0, 188, 212, 0.8)',
            pointBorderWidth: 1
        }]
        },
        options: {
            responsive: true,
            legend: false
        }
      });
    },


    presentase_jenis_kelamin: function() {
      var ctx = document.getElementById("presentase_jenis_kelamin").getContext("2d");

      var myChart = new Chart(ctx, {
        type: 'pie',
        data: {
            datasets: [{
                data: [this.data.jml_wanita, this.data.jml_pria],
                backgroundColor: [
                    "rgb(255, 193, 7)",
                    "rgb(0, 188, 212)",               ],
            }],
            labels: [
                "Wanita",
                "Pria",
            ]
        },
        options: {
            responsive: true,
            legend: false
        }
      });
    }


// ========================================== CHART ===========================================

  },
  mounted() {
    localStorage.sidemenu = 'simpeg';
    
    this.getData();
    
    






  }
};
</script>
